import { send_request } from './Request';

const ENDPOINT = 'project-service/project-session/rollout-metrics/event';

const emitEvent = (eventType, projectId, clientId, payload) => {
  try {
    send_request(ENDPOINT, '', { eventType, projectId, clientId, payload }, 'post').catch(() => {
      // Fire-and-forget — never block UI on telemetry failure.
    });
  } catch (_) {
    // Swallow synchronous errors (e.g. missing send_request).
  }
};

export function emitSessionPaneRenderPath({ projectId, clientId, path }) {
  emitEvent('SESSION_PANE_RENDER_PATH', projectId, clientId, { path });
}

export function emitPlaceholderMapSource({ projectId, clientId, source }) {
  emitEvent('PLACEHOLDER_MAP_SOURCE', projectId, clientId, { source });
}

export function emitPlaceholderParityMismatch({ projectId, clientId, comparison }) {
  emitEvent('PLACEHOLDER_PARITY_MISMATCH', projectId, clientId, {
    canonicalCount: comparison?.canonicalCount ?? 0,
    fallbackCount: comparison?.fallbackCount ?? 0,
    onlyCanonicalCount: comparison?.onlyCanonical?.length ?? 0,
    onlyFallbackCount: comparison?.onlyFallback?.length ?? 0,
  });
}
